import { Card } from "@mui/material";
import React from "react";
import Flex from "../../../../../components/Flex";
import Text from "../../../../../components/Text";
import StyledButtonV2 from "../../../../../components/app/StyledButtonV2";
import { CARD_STYLES, COLORS } from "../constants";
import { Action } from "../patient-portal-dashboard.types";

interface ActionItemProps {
  action: Action;
  onActionClick?: (actionId: string) => void;
}

const ActionItem: React.FC<ActionItemProps> = ({ action, onActionClick }) => {
  const handleClick = () => onActionClick?.(action.uuid);

  return (
    <Card
      variant="outlined"
      sx={{ ...CARD_STYLES, width: "100%", height: "46px" }}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        gap={1}
        height="100%"
        px={1}
      >
        <Text size="14px" c={COLORS.textPrimary}>
          {action.description}
        </Text>
        <StyledButtonV2
          sx={{
            backgroundColor: COLORS.actionButtonBg,
            color: COLORS.actionButtonColor,
            height: "26px",
            minWidth: "fit-content",
            whiteSpace: "nowrap",
            "&:hover": {
              backgroundColor: COLORS.rescheduleBg,
            },
          }}
          label={action.buttonText}
          variant={action.buttonVariant}
          onClick={handleClick}
        />
      </Flex>
    </Card>
  );
};

export default ActionItem;
